import { render } from "./PdfList.vue?vue&type=template&id=17cca7a1"
import script from "./PdfList.vue?vue&type=script&lang=js"
export * from "./PdfList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__